// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18euW","col":"styles_col__Xy-eb","actions":"styles_actions__1ZCDZ","conflict":"styles_conflict__281Xn"};